<template>
  <el-menu-item v-if="children.length == 0" :index="path">
    {{ mdata.title }}
  </el-menu-item>
  <el-submenu v-else :popper-append-to-body="ppath === ''" :index="path">
    <template slot="title">
      <span> {{ mdata.title }}</span>
    </template>
    <navi-item v-for="(m, k) in children" :key="k" :mdata="m" :ppath="path">
    </navi-item>
  </el-submenu>
</template>

<script>
export default {
  name: 'NaviItem',
  props: {
    mdata: {
      type: Object,
      required: true
    },
    ppath: {
      type: String,
      required: false,
      default: ''
    }
  },
  computed: {
    path() {
      return `${this.ppath}/${this.mdata.path}`
    },
    children() {
      return this.mdata.children || []
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/NaviItem.vue